import axiosInstance from "../axios/axios_instance";
const http = axiosInstance("/protected",  null, null);

const registerAffiliateCookie = (cookie) =>
    http.post("/register_affiliate_cookie", {"affiliateCookie": cookie}, { withCredentials: true });


export default {
    registerAffiliateCookie
};